var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "inquiryDetail"
  }, [_c("div", {
    staticClass: "modular"
  }, [_c("h3", [_vm._v(_vm._s(_vm.$t("inquiryDetail.product")))]), _c("div", {
    staticClass: "productList"
  }, [_c("div", {
    staticClass: "orderChannel"
  }, [_c("div", {
    staticStyle: {
      flex: "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("inquiryList.askPriceNo")) + "：" + _vm._s(_vm.productInfo.orderNo) + " "), _c("a-tag", {
    staticClass: "orderStatus",
    attrs: {
      color: "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm.productInfo.orderStatus == 1 ? _vm.$t("public.orderStatus2") : _vm.productInfo.orderStatus == 2 ? _vm.$t("public.orderStatus99") : _vm.$t("public.orderStatus7")) + " "), _vm.orderStatusList.length > 0 ? _c("div", {
    staticClass: "orderStatusList"
  }, [_c("a-steps", {
    attrs: {
      "progress-dot": "",
      direction: "vertical"
    }
  }, _vm._l(_vm.orderStatusList, function (Status, key) {
    return _c("a-step", {
      key: key,
      attrs: {
        title: _vm.getStatus(Status),
        status: "finish"
      }
    });
  }), 1)], 1) : _vm._e()])], 1), _c("div", {
    staticStyle: {
      flex: "2"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("inquiryList.naDate")) + "：" + _vm._s(_vm.productInfo.arriveDate) + " " + _vm._s(_vm.productInfo.arriveTime >= 0 ? _vm.$t("public.arriveItem".concat(_vm.productInfo.arriveTime)) : "") + " "), _c("br")])]), _c("a-table", {
    attrs: {
      pagination: false,
      bordered: "",
      columns: _vm.columns,
      rowKey: "productNo",
      "data-source": _vm.productInfo.productList
    },
    scopedSlots: _vm._u([{
      key: "productName",
      fn: function fn(text, record) {
        return _c("span", {}, [record.productType == 0 ? _c("router-link", {
          attrs: {
            target: "_blank",
            to: {
              path: "/productmanager/productDetail",
              query: {
                id: record.productId
              }
            }
          }
        }, [_vm._v(_vm._s(record.productName + "  " + record.productSpecification))]) : _c("span", [_vm._v(_vm._s(record.productName + "  " + record.productSpecification))]), _c("br"), _c("span", [_vm._v(_vm._s(_vm.$t("inquiryDetail.transportName")) + "：" + _vm._s((record.transportName ? record.transportName : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("inquiryDetail.chineseName")) + "：" + _vm._s((record.traditionalProductName ? record.traditionalProductName : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("inquiryDetail.rongliang")) + "：" + _vm._s((record.capacity ? record.capacity : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("inquiryDetail.rushu")) + "：" + _vm._s((record.caseQuantity ? record.caseQuantity : "--") + "   "))]), _c("span", [_vm._v(_vm._s("JAN") + "：" + _vm._s((record.janCode ? record.janCode : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("inquiryDetail.brand")) + "：" + _vm._s((record.productBrand ? record.productBrand : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("inquiryDetail.source")) + "：" + _vm._s((record.productSourcearea ? record.productSourcearea : "--") + "   "))])], 1);
      }
    }, {
      key: "caseOrItem",
      fn: function fn(text, record) {
        return _c("span", {}, [record.caseOrItem ? _c("span", [_vm._v(_vm._s(record.caseOrItem == 1 ? _vm.$t("inquiryDetail.totalBox") : _vm.$t("inquiryDetail.sanBox")))]) : _c("span", [_vm._v("--")])]);
      }
    }])
  })], 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };